import StripePaymentMethodFragment from './StripePaymentMethodFragment';
export default `
  fragment PaymentMethodFragment on PaymentMethod {
    id
    alias
    type
    name
    description
    provider
    meta
    reference {
      ...StripePaymentMethodFragment
    }
  }
  ${StripePaymentMethodFragment}
`;
